import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";

export function AuthLayout() {
  const [checkoutEnabled, setCheckoutEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await fetch("/api/billing/config");
        if (res.ok && !cancelled) {
          const config = (await res.json()) as { checkoutEnabled?: boolean };
          setCheckoutEnabled(Boolean(config.checkoutEnabled));
        }
      } catch {
        // leave false — checkout assumed unavailable
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[radial-gradient(circle_at_top,_rgba(14,165,233,0.16),_transparent_32%),linear-gradient(180deg,#f8fafc_0%,#ffffff_38%,#f8fafc_100%)] px-4 py-12">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(148,163,184,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(148,163,184,0.06)_1px,transparent_1px)] bg-[size:88px_88px] [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0.2))]" />

      <div className="relative flex flex-col items-center">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-2 text-xl font-semibold text-slate-950 transition hover:text-sky-600"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-slate-950 text-xs font-bold text-white">
            RE
          </span>
          React Email Builder
        </Link>
        <Outlet />
      </div>

      <p className="relative mt-12 text-center text-xs text-slate-400">
        Free tier · No credit card required{checkoutEnabled ? " · Cancel anytime" : ""}
      </p>

      <div className="relative mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-slate-400">
        <span className="inline-flex items-center gap-1.5">
          <svg aria-hidden="true" className="h-3.5 w-3.5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
          148+ templates
        </span>
        <span className="inline-flex items-center gap-1.5">
          <svg aria-hidden="true" className="h-3.5 w-3.5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
          AI-powered generation
        </span>
        <span className="inline-flex items-center gap-1.5">
          <svg aria-hidden="true" className="h-3.5 w-3.5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
          HTML + React export
        </span>
      </div>
    </section>
  );
}